<template>
  <div class="uk-width-1-1">
    <form-row>
      <label><input
        v-model="$v.role.$model"
        type="radio"
        class="registrarRole__input"
        name="registrar_role"
        value="student"
        :disabled="disabled"
      > {{ $t('events.i_am_the_student') }}</label>
    </form-row>
    <form-row>
      <label><input
        v-model="$v.role.$model"
        class="registrarRole__input"
        type="radio"
        name="registrar_role"
        value="guardian"
        :disabled="disabled"
      > {{ $t('events.i_am_the_parent_guardian') }}</label>
    </form-row>
    <form-row>
      <label><input
        v-model="$v.role.$model"
        type="radio"
        class="registrarRole__input"
        name="registrar_role"
        value="school"
        :disabled="disabled"
      > {{ $t('events.i_am_the_school_owner') }}</label>
    </form-row>
    <form-row v-if="event.data.spectator_division_id > 0">
      <label><input
        v-model="$v.role.$model"
        type="radio"
        class="registrarRole__input"
        name="registrar_role"
        value="spectator"
        :disabled="disabled"
      > {{ $t('events.i_am_a_spectator') }}</label>
    </form-row>

    <p
      v-if="$v.$invalid && $v.$dirty"
      class="uk-text-danger"
    >
      {{ $t('events.registrar_role_required') }}
    </p>
  </div>
</template>

<script lang="ts">
import {Component, Prop} from 'vue-property-decorator';
import formRow from '../form/form-row.vue';
import {validationMixin} from "vuelidate";
import { required } from 'vuelidate/lib/validators';
import FormStep from "./FormStep";
import EventModel from "../../models/EventModel";

@Component({
  components: {
    'form-row': formRow
  },
  mixins: [validationMixin],
  validations: {
    role: {
      required
    }
  }
})
export default class RegistrarTypeChoice extends FormStep {
  @Prop() value!: string;
  @Prop() event!: EventModel;

  get role(): string {
    return this.value;
  }

  set role(v: string) {
    this.$emit('input', v);
  }
}
</script>

<style scoped>
.registrarRole__input {
  vertical-align: middle;
}
</style>
